module.exports = __webpack_public_path__ + "img/trophy-img.f2ae90ae.png";